/**
 *
 * Disclaimer: Source code mentioned below is(are) Intellectual Property of
 * Crayon Data Holdings Limited (including its subsidiaries and affiliates).
 * Crayon Data Holdings Limited reserves right to own and control it the way
 * it may deem fit. You must refrain from use, access, read, modify, add or
 * delete, sell or use in any other package or programme pertaining to such
 * source code without explicit prior written approval of
 * Crayon Data Holding Limited. Breach of the same shall attract penalty as
 * applicable.
 *
 */

// MerchantDetails Component
import React, { Component } from "react";

// Import Component
import MerchantDetails from "../../components/MerchantDetails";
//import AMerchantDetails from "../../components/ADIBMerchantDetails";
import ContentLoader from "react-content-loader";
import Breadcrumb from "../../components/Bredcrumb";
import Icon from "../../components/Icons";
import ErrorComponent from "../../components/ErrorPageComponent/errorComponent";

import {
  getItemDetail,
  getExpiredItemDetail,
  getSimilarItem,
  getError,
  interaction,
  randomTokenGen,
  updateUser
} from "../../service";
import { deepEqual,getQuery } from "../../pages/helper";

import PageBase from "../PageBase";
import { withRouter } from "react-router";
import config from "../../service/config";
import { accessTokenHelper } from "../../helper/token";
import { tokenHeader } from "../../constants";
const lang = localStorage.getItem("language");

//Import Config
var MatomoTracker = require("matomo-tracker");
var matomo = new MatomoTracker(config.siteId, config.siteURL);
class MerchantDetailsCompnent extends Component {
  state = {
    cardItem: null,
    activeMenu: localStorage.getItem("tab"),
    countryList: [],
    categoryList: [],
    category: {
      value: "all",
      label: "Recommended"
    },
    reacentSearch: [],
    simillarItems: [],
    typeAhead: [],
    userData: null,
    isLoad: true,
    merUserid : null,
  };

  componentDidMount() {
    this.props.getData();
    let ids = this.props.location.pathname.split("/").slice(3);
    const fromsearch = this.props.location?.state?.from;
    this.setState({merUserid:localStorage.getItem("USERID")})
    // localStorage.setItem("isLoggedin", 'false')
    const token = randomTokenGen(16);
    let userId = ids[1];
    // let userId = ids[1] ? ids[1] && localStorage.setItem("isLoggedin", 'true') : token ;
    let cardId = ids[0];
    if (ids[1]) {
      userId = ids[1] 
      localStorage.setItem("isLoggedin", 'true') 
    }
    else if (localStorage.getItem("USERID") === undefined || localStorage.getItem("USERID") === null) {
     userId = token;
     localStorage.setItem("USERID" , token)
      localStorage.setItem("isLoggedin", 'false')
    }
    else if (localStorage.getItem("isLoggedin") !== "true" && fromsearch ===undefined ) {
      userId=localStorage.getItem("USERID") 
      localStorage.setItem("isLoggedin", 'false')
    }
    else if (localStorage.getItem("isLoggedin") !== "true" && fromsearch !==undefined ) {
      localStorage.setItem("isLoggedin", 'false')
    }
    else if(localStorage.getItem("isLoggedin")==="true"){
      localStorage.setItem("isLoggedin", 'true')
    }
    localStorage.removeItem("api_status_merchant");
    let type = getQuery(this.props.location.search, 'sourceType');
    const searchParams = new URLSearchParams(this.props.location.search);
    const Crayonid = searchParams.get("crayonid");
    const Rid = searchParams.get("rid");
    const from  =  searchParams.get('from');
    if (userId) {
      //accessTokenHelper.set(userId);
      localStorage.setItem(tokenHeader.TOKEN, Crayonid? Crayonid :userId);
      localStorage.setItem("USERID",Crayonid? Crayonid : userId);
      sessionStorage.setItem("USERID", Crayonid? Crayonid :userId);
      from === "expired" ? this.props.history.push("/home/merchant/" + cardId + "?from=expired", this.props?.location?.state) : this.props.history.push("/home/merchant/" + cardId, this.props?.location?.state);
      this.props.setRightMenuActive("");
      //Get card ID
      if (Rid) {
        matomo.track({
          url: window.location.href,
          uid: Crayonid? Crayonid : userId ? userId : localStorage.getItem("TOKEN"),
          e_c: 'Rid',
          e_a: 'Rid',
          e_n: Rid
         })
      }
      if(type){
          matomo.track({
          url: window.location.href,
          uid: Crayonid? Crayonid : userId ? userId : localStorage.getItem("TOKEN"),
          //_cvar : JSON.stringify({'1': ["sourceType" ,type] }) 
          e_c: 'sourceType',
          e_a: type,
          e_n: Crayonid? Crayonid : userId ? userId : localStorage.getItem("TOKEN")
          })
        }else{
          matomo.track({
            url: window.location.href,
            uid: userId
          })
        }
      // this.getMerchantItem(cardId);
      // this.getMerchantSimilarItem(cardId);
      // this.props.getData();
      // this.patchApi(cardId);
      this.getMerchantItem(cardId);
      this.getMerchantSimilarItem(cardId);
      window.scrollTo(0, 0);
      setTimeout(() => {
        this.setState({ isLoad: false });
      }, 1500);
    } else {
      this.props.setRightMenuActive("");
      //Get card ID
      if(type){
          matomo.track({
          url: window.location.href,
          uid: localStorage.getItem("TOKEN"),
          //_cvar : JSON.stringify({'1': ["sourceType" ,type] }) 
          e_c: 'sourceType',
          e_a: type,
          e_n: userId
          })
        }else{
          matomo.track({
            url: window.location.href,
            uid: localStorage.getItem("TOKEN")
          })
        }

      // this.patchApi(cardId);
      this.getMerchantItem(cardId);
      this.getMerchantSimilarItem(cardId);
      // this.props.getData();
      window.scrollTo(0, 0);
      setTimeout(() => {
        this.setState({ isLoad: false });
      }, 1500);
    }
  }

  patchApi = (cardId) => {
    updateUser().then((res)=> {
      if(res) {
        this.getMerchantItem(cardId);
        this.getMerchantSimilarItem(cardId);
      }
    }).catch((err)=>{
      console.log("error")
    })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.id !== this.props.match.params.id) {
      let ids = this.props.location.pathname.split("/").slice(3);
      let userId = ids[1];
      let cardId = ids[0];
      if (userId) {
        //accessTokenHelper.set(userId);
        localStorage.setItem(tokenHeader.TOKEN, userId);
        localStorage.setItem("USERID", userId);
        sessionStorage.setItem("USERID", userId);
        this.props.history.push("/home/merchant/" + cardId);
      }
      this.patchApi(cardId);
    }
    if(this.state.merUserid !== localStorage.getItem("USERID") && this.state.merUserid !== null){
      this.setState({merUserid:localStorage.getItem("USERID")})
      this.setState({cardItem:null})
      let ids = this.props.location.pathname.split("/").slice(3);
      let cardId = ids[0];
      this.patchApi(cardId);
    }
    window.onpopstate = (e) => {
      this.props.setActiveMenu(sessionStorage.getItem("actMenu") || "home");
    };
  }

  _onChangeTab = (activeMenu) => {
    this.props._onChangeTab(activeMenu);
    this.props.getData();
  };

  getMerchantItem(cardId) {
    // this.userInteraction(cardId, "VIEW");
    const searchParams = new URLSearchParams(this.props.location.search)
    const from  =  searchParams.get('from');
    // console.log(from , "qaz")
    if(from === "expired"){ 
      getExpiredItemDetail(cardId)
      .then((res) => {
        if (res) {
          this.setState({ cardItem: res });
          this.userInteraction(cardId, "VIEW",res);
        }
        Promise.resolve(null);
      })
      .catch((err) => {
        if (
          ![400, 402, 404, 500].includes(
            Number(localStorage.getItem("api_status_merchant"))
          )
        ) {
          localStorage.setItem("api_status_merchant", "api_downtime");
        }
        console.log(getError(err));
      });
    }
    else{
      getItemDetail(cardId)
      .then((res) => {
        if (res) {
          this.setState({ cardItem: res ,isLoad:false });
          this.userInteraction(cardId, "VIEW",res);
        }
        Promise.resolve(null);
      })
      .catch((err) => {
        if (
          ![400, 402, 404, 500].includes(
            Number(localStorage.getItem("api_status_merchant"))
          )
        ) {
          localStorage.setItem("api_status_merchant", "api_downtime");
        }
        console.log(getError(err));
      });
    }
  }

  userInteraction = (itemId, type, res) => {
    if(res.itemType === "PORTFOLIO_OFFERS"){
      interaction(type, "PORTFOLIO_OFFERS", itemId)
      .then((res) => {})
      .catch((err) => {
        if (err && err.data && err.data.status === 404) {
        } else {
          //   console.log(getError(err));
        }
      });
    }
    else if (res.itemType === "PORTFOLIO_OFFERS") {
      interaction(type, "PORTFOLIO_OFFERS", itemId)
      .then((res) => {})
      .catch((err) => {
        if (err && err.data && err.data.status === 404) {
        } else {
          //   console.log(getError(err));
        }
      });
    }
    else if (res.itemType === "FINANCIAL_PRODUCT") {
      interaction(type, "FINANCIAL_PRODUCT", itemId)
      .then((res) => {})
      .catch((err) => {
        if (err && err.data && err.data.status === 404) {
        } else {
          //   console.log(getError(err));
        }
      });
    }
    else{
      interaction(type, "MERCHANT", itemId)
      .then((res) => {})
      .catch((err) => {
        if (err && err.data && err.data.status === 404) {
        } else {
          //   console.log(getError(err));
        }
      });
    }
  };

  getMerchantSimilarItem(cardId) {
    getSimilarItem(cardId, 6,this.props?.activeMenu)
      .then((res) => {
        if (res.length > 0) {
          this.setState({ simillarItems: res });
        }
        Promise.resolve([]);
      })
      .catch((err) => {
        //   console.log(getError(err));
      });
  }

  setActiveMenu = (path) => {
    this.props.setActiveMenu(path);
  };

  /* Other Render Function */
  _renderMerchantDetails() {
    const { cardItem, countryList, simillarItems } = this.state;
    if (!cardItem) {
      if (window.innerWidth > 1500) {
        return (
          <div className="loder-div merchant">
            <ContentLoader
              speed={0.7}
              width="100vw"
              height={800}
              rtl={lang === "AR" ? true : false}
            >
              <rect x="0" y="0" rx="0" ry="0" width="100vw" height="300" />
            </ContentLoader>
          </div>
        );
      } else {
        return (
          <div className="loder-div merchant">
            <ContentLoader
              speed={0.7}
              width="100vw"
              height={800}
              rtl={lang === "AR" ? true : false}
            >
              <rect x="0" y="0" rx="0" ry="0" width="100vw" height="300" />
            </ContentLoader>
          </div>
        );
      }
    }

    return config.clientName === "ADIB" ? (
      <MerchantDetails
        item={cardItem}
        _openLogin={this.props._openLogin}
        countryList={countryList}
        allOffersList={simillarItems}
        history={this.props.history}
        setActiveMenu={this.setActiveMenu}
        _onChangeTab={this._onChangeTab}
      />
    ) : (
      <MerchantDetails
        item={cardItem}
        _openLogin={this.props._openLogin}
        countryList={countryList}
        allOffersList={simillarItems}
        history={this.props.history}
        setActiveMenu={this.setActiveMenu}
        _onChangeTab={this._onChangeTab}
      />
    );
  }

  goBack = () =>
    this.props.history.push("/home/search", {
      searchKeyword: this.props.location.state.from
    });

  /* Main Render Functions */
  render() {
    return (
      <div className="col-md-12 p-0 mobile-detail-page">
        {/* {this._renderBreadcrumb()} */}
        {Number(localStorage.getItem("api_status_merchant")) === 400 ||
        Number(localStorage.getItem("api_status_merchant")) === 402 ? (
          <ErrorComponent
            title="Something went wrong"
            description="Please try again."
          />
        ) : Number(localStorage.getItem("api_status_merchant")) === 500 ? (
          <ErrorComponent
            title="Something went wrong"
            description="Please try again later."
          />
        ) : Number(localStorage.getItem("api_status_merchant")) === 404 && this.state.cardItem === null  ? (
          <ErrorComponent
            title="Page not found"
            description="Try refreshing the page or go back to the homepage."
          />
        ) : localStorage.getItem("api_status_merchant") === "api_downtime" ? (
          <ErrorComponent
            title="Service unavailable"
            description="Due to scheduled maintenance, this service is unavailable. We apologise for the inconvenience, please come back later."
          />
        ) : (
          <>{this._renderMerchantDetails()}</>
        )}
      </div>
    );
  }
}

export default withRouter(MerchantDetailsCompnent);
